<span class="route-tag gap-1">
  <img src="assets/images/icons/svg/route-icon.svg" alt="icon" class="icon -ml-2" />
  <span>Route</span>
</span>
